const menuDataHardcoded = {
  mainMenu: [
    {
      label: 'Investing',
      submenu: 'investing',
      hasSubmenu: true,
      items: [
        {
          category: 'Our accounts',
          submenuId: 'ourAccountsMenu',
          links: [
            {
              title: 'Stocks & shares ISA',
              href: '/isa/stocks-shares-isa',
              desc: 'Invest up to £20,000 each tax year, with tax-free growth',
            },
            {
              title: 'Self-invested personal pension (SIPP)',
              href: '/pensions/sipp',
              desc: 'Plan for retirement with our Which? recommended pension account',
            },

            {
              title: 'Ready-made pension',
              href: '/pensions/ready-made-pension',
              desc: "Our low-cost, hassle-free ready-made pension that's managed for you",
            },
            {
              title: 'Dealing account',
              href: '/dealing-account',
              desc: 'Invest your money your way with our general investment account',
            },
            {
              title: 'Lifetime ISA',
              href: '/isa/lifetime-isa',
              desc: 'The ISA designed to help you save for your first home or retirement',
            },
            {
              title: 'Junior ISA',
              href: '/isa/junior-isa',
              desc: 'Invest for the little one in your life with a Junior ISA',
            },
            {
              title: 'Cash savings hub',
              href: '/isa/junior-isa',
              desc: "Access savings interest rates you won't find on the high street",
            },
          ],
          features: [
            {
              title: 'Charges & rates',
              href: '/charges-and-rates',
              desc: 'Understand what our charges and rates mean for you',
              icon: `<svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 384 512"
                                aria-hidden="true" focusable="false" role="img"
                              >
                                <path d="M352 160l0 288c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-288 320 0zm0-32L32 128l0-64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64zm32 0l0-64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64l0 64 0 16 0 16L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288 0-16 0-16zM72 224a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM264 416a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM80 400c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 400z"></path>
                              </svg>`,
            },
            {
              title: 'All accounts',
              href: '/investment/accounts',
              desc: 'All our accounts under one roof. Find an account that suits you',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false" role="img">
													<path d="M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM32 480l384 0c-1.2-79.7-66.2-144-146.3-144l-91.4 0c-80 0-145 64.3-146.3 144zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"></path>
												</svg>`,
            },
          ],
        },
        {
          category: 'Choose your investments',
          submenuId: 'chooseInvestmentsMenu',
          links: [
            {
              title: 'Shares',
              href: '/investment/shares',
              desc: 'Find, research, buy and sell shares from across the globe',
            },
            {
              title: 'Funds',
              href: '/investment/funds',
              desc: 'Explore the universe of funds we have available to invest in',
            },
            {
              title: 'ETFs',
              href: '/investment/exchange-traded-funds',
              desc: 'Choose funds from a broad range of indices and benchmarks',
            },
            {
              title: 'Investment trusts',
              href: '/investment/investment-trusts',
              desc: 'From income to growth, explore our range of investment trusts',
            },
            {
              title: 'Bonds & gilts',
              href: '/investment/bonds',
              desc: 'Our full range of bonds and securities for low-volatility investing',
            },
            {
              title: 'International dealing',
              href: '/investment/international',
              desc: 'All the international markets you can invest in, and how to do it',
            },
          ],
          features: [
            {
              title: 'See all investments',
              href: '/investment',
              desc: 'Our full range of investments, so you can build the ideal portfolio',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" aria-hidden="true" focusable="false" role="img">
													<path d="M170.1 33.1c3.3-1.3 6.9-1.5 10.3-.5L399.1 95.1l144-57.6c15.8-6.3 32.9 5.3 32.9 22.3l0 334.8c0 9.8-6 18.6-15.1 22.3l-155 62c-3.3 1.3-6.9 1.5-10.3 .5L176.9 416.9l-144 57.6C17.1 480.8 0 469.2 0 452.2L0 117.4c0-9.8 6-18.6 15.1-22.3l155-62zM32 122.8l0 317.5 128-51.2 0-317.5L32 122.8zm352 320l0-318.7L192 69.2l0 318.7 192 54.9zm32-2.4l128-51.2 0-317.5L416 122.8l0 317.5z"></path>
												</svg>`,
            },
            {
              title: 'Investment ideas',
              href: '/investment/ideas',
              desc: 'Unsure where to invest? Let us help you',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" aria-hidden="true" focusable="false" role="img">
													<path d="M170.1 33.1c3.3-1.3 6.9-1.5 10.3-.5L399.1 95.1l144-57.6c15.8-6.3 32.9 5.3 32.9 22.3l0 334.8c0 9.8-6 18.6-15.1 22.3l-155 62c-3.3 1.3-6.9 1.5-10.3 .5L176.9 416.9l-144 57.6C17.1 480.8 0 469.2 0 452.2L0 117.4c0-9.8 6-18.6 15.1-22.3l155-62zM32 122.8l0 317.5 128-51.2 0-317.5L32 122.8zm352 320l0-318.7L192 69.2l0 318.7 192 54.9zm32-2.4l128-51.2 0-317.5L416 122.8l0 317.5z"></path>
												</svg>`,
            },
          ],
        },
      ],
    },
    {
      label: 'ISAs',
      submenu: 'isas',
      hasSubmenu: true,
      items: [
        {
          category: 'ISA accounts',
          submenuId: 'isaAccountsMenu',
          links: [
            {
              title: 'Stocks & shares ISA',
              href: '/isa/stocks-shares-isa',
              desc: 'Invest up to £20,000 each tax year, with growth tax-free',
            },
            {
              title: 'Lifetime ISA',
              href: '/isa/lifetime-isa',
              desc: 'The ISA designed to help you save for your first home or retirement',
            },
            {
              title: 'Junior ISA',
              href: '/isa/junior-isa',
              desc: 'Invest for the little one in your life with a Junior ISA',
            },
            {
              title: 'All ISA accounts',
              href: '/isa',
              desc: 'Explore and compare all our ISA accounts',
            },
          ],
        },
        {
          category: 'Managing an ISA',
          submenuId: 'managingIsaMenu',
          links: [
            {
              title: 'ISA allowances',
              href: '/isa/isa-allowances',
              desc: 'Understand how to make the most of your tax-free allowancee',
            },
            {
              title: 'Transfer an ISA',
              href: '/isa/transfer',
              desc: 'Move your money over to one of our low-cost, easy-to-manage ISAs',
            },
            {
              title: 'Multiple ISAs',
              href: '/isa/multiple-accounts',
              desc: 'Learn more about how to split your annual allowance',
            },
            {
              title: 'ISA essentials',
              href: '/learn/investing-essentials',
              desc: 'Everything you need to know about saving and investing in ISAs',
            },
            {
              title: 'What is an ISA?',
              href: '/isa/stocks-shares-isa/what-is',
              desc: 'Understand the different types of ISAs, the benefits and how to start',
            },
          ],
        },
      ],
    },
    {
      label: 'Pensions',
      submenu: 'pensions',
      hasSubmenu: true,
      items: [
        {
          category: 'Pension accounts',
          submenuId: 'pensionAccountsMenu',
          links: [
            {
              title: 'Self-invested personal pension (SIPP)',
              href: '/pensions/sipp',
              desc: 'Plan for retirement with our Which? recommended pension account',
            },
            {
              title: 'Ready-made pension',
              href: '/pensions/ready-made-pension',
              desc: "Our low-cost, hassle-free ready-made pension that's managed for you",
            },
            {
              title: 'Junior SIPP',
              href: '/pensions/junior-sipp',
              desc: 'Starting building a pension for the little one in your life',
            },
            {
              title: 'All pension accounts',
              href: '/pensions',
              desc: "Build a pension that's perfect for you with our accounts and guides",
            },
          ],
        },
        {
          category: 'Saving for retirement',
          submenuId: 'savingRetirementMenu',
          links: [
            {
              title: 'Find my pensions',
              href: '/pensions/find-my-pensions',
              desc: 'Our FREE service that tracks down your lost workplace pensions',
            },
            {
              title: 'Pension consolidation',
              href: '/pensions/consolidating-pensions',
              desc: 'Streamline your retirement savings with our consolidation service',
            },
            {
              title: 'Transfer a pension',
              href: '/transfer',
              desc: 'Transfer your money to the seven-time Which? recommended platform',
            },
            {
              title: 'Pension builder fund',
              href: '/pensions/builder',
              desc: 'The classic, balanced fund designed for long-term, stable growth',
            },
            {
              title: 'Pension essentials',
              href: '/pensions/learn',
              desc: 'A library of guides to help you build a pension that works for you',
            },
            {
              title: 'What is a SIPP?',
              href: '/pensions/sipp/what-is',
              desc: 'Understand the finer points of opening and managing a SIPP',
            },
          ],
        },
        {
          category: 'Approaching retirement',
          submenuId: 'approachingRetirementMenu',
          links: [
            {
              title: 'Accessing your pension',
              href: '/retirement',
              desc: 'Your pension options explained, to get you ready for retirement',
            },
            {
              title: 'Drawdown',
              href: '/pensions/drawdown',
              desc: 'Unlock flexible retirement income and control your finances',
            },
            {
              title: 'Investing in retirement',
              href: '/pensions/investing-in-later-life',
              desc: 'Strategies to help you grow your wealth in retirement',
            },
          ],
        },
      ],
    },
    {
      label: 'News & Insights',
      href: '/news',
      hasSubmenu: false,
    },
    {
      label: 'Help & Education',
      submenu: 'help',
      hasSubmenu: true,
      items: [
        {
          category: 'Learn to invest',
          submenuId: 'learnInvestMenu',
          links: [
            {
              title: 'Learn hub',
              href: '/learn',
              desc: 'A wealth of resources to help inform your investment decisions',
            },
            {
              title: 'Investing essentials',
              href: '/learn/investing-essentials',
              desc: 'Master the fundamentals of investing with our collection of guides',
            },
            {
              title: 'Building your portfolio',
              href: '/learn/building-your-portfolio',
              desc: 'Our experts share tips and insight on crafting your ideal portfolio',
            },
            {
              title: 'Jargon buster',
              href: '/learn/jargon',
              desc: 'Demystify the world of financial terminology the easy way',
            },
            {
              title: 'Money & markets podcast',
              href: '/learn/podcast',
              desc: 'Join our experts as they debate and dissect the latest stories',
            },
            {
              title: 'Money matters',
              href: 'https://www.ajbellmoneymatters.co.uk/',
              desc: 'Our dedicated space to help women feel good, investing',
            },
          ],
        },
        {
          category: 'Support',
          submenuId: 'supportMenu',
          links: [
            {
              title: 'Contact us',
              href: '/can-we-help',
              desc: 'Our support team are on hand to help you whenever you need',
            },
            {
              title: 'FAQs',
              href: '/faq',
              desc: 'Find answers to common questions instantly with our FAQs',
            },
            {
              title: 'Security centre',
              href: '/security-centre',
              desc: 'How we keep you, your account, and your investments safe',
            },
          ],
        },
      ],
    },
    {
      label: 'New to AJ Bell',
      submenu: 'newToAjBell',
      hasSubmenu: true,
      items: [
        {
          category: 'About us',
          desc: 'Learn why over 500,000 customers invest their money with us',
          href: '/about-us',
        },
        {
          category: 'New to investing',
          desc: 'Never invested before? Our Dodl accounts may be right for you',
          href: '/new-to-investing',
        },
        {
          category: 'Our awards',
          desc: "We're one of the most awarded platforms around. See what we've won",
          href: '/awards',
        },
        {
          category: 'Transfer to AJ Bell',
          desc: "Looking to move to us? We'll do all the heavy lifting for you",
          href: '/transfer',
        },
        {
          category: 'Special offers',
          desc: 'Don’t miss our latest transfer and referral offers',
          href: '/investment/accounts/offers',
        },
        {
          category: 'AJ Bell app',
          desc: 'Manage your money on the move, with the AJ Bell app',
          href: '/investment/accounts/features',
        },
      ],
    },
    {
      label: 'Account',
      submenu: 'myAccount',
      hasSubmenu: true,
      isLastItem: true,
      items: [
        {
          category: 'Portfolio & dealing',
          submenuId: 'portfolioDealingMenu',
          links: [
            {
              title: 'Account overview',
              href: '/platform/overview',
              desc: 'Your AJ Bell accounts summary',
            },
            {
              title: 'Portfolio overview',
              href: '/platform/portfolio',
              desc: 'Check your porfolio details and performance',
            },
            {
              title: 'Buy and sell',
              href: '/platform/trade',
              desc: 'Search for an investment by name, ticker, or sedol',
            },
            {
              title: 'Active orders',
              href: '/platform/orders',
              desc: 'See your upcoming investments',
            },
            {
              title: 'Regular investments',
              href: '/platform/regularinvestments',
              desc: 'Set up monthly investments starting at £25 per month',
            },
            {
              title: 'Dividends & income',
              href: '/platform/dividends-and-income',
              desc: 'See all income, dividends, and cash payments from your investments',
            },
            {
              title: 'Find my pensions',
              href: '/platform/pensionfinder',
              desc: "Looking for old pensions? We'll find them for free",
            },
          ],
        },
        {
          category: 'Manage payments',
          submenuId: 'managePaymentsMenu',
          links: [
            {
              title: 'Single payment',
              href: '/platform/singlepayment',
              desc: 'Add money to your account with a one-off payment',
            },
            {
              title: 'Regular payment',
              href: '/platform/regularpayments',
              desc: 'Set up a direct debit or amend or cancel an existing one',
            },
            {
              title: 'Withdrawals',
              href: '/platform/withdrawcash',
              desc: 'Take money out of your AJ Bell account',
            },
            {
              title: 'Move cash between accounts',
              href: '/platform/movecash',
              desc: 'Switch cash between your AJ Bell accounts',
            },
            {
              title: 'Manage my pension',
              href: '/platform/manage-my-pension',
              desc: 'Review and update your pension details and contributions',
            },
          ],
        },
        {
          category: 'Documents and statements',
          submenuId: 'documentsStatementsMenu',
          links: [
            {
              title: 'Transaction history',
              href: '/platform/history',
              desc: 'See the full history of your account',
            },
            {
              title: 'Cash statement',
              href: '/platform/statements',
              desc: 'View and download your cash statements and balance',
            },
            {
              title: 'Corporate actions',
              href: '/platform/corporateactions',
              desc: 'See any actions or corporate updates on specific investments',
            },
            {
              title: 'Documents',
              href: '/platform/documents',
              desc: 'View tax summaries, quarterly statements and more',
            },
            {
              title: 'Voting instructions',
              href: '/platform/voting-instructions',
              desc: 'Vote in company AGMs or special events',
            },
          ],
        },
        {
          category: 'My account management',
          submenuId: 'myAccountManagementMenu',
          links: [
            {
              title: 'Transfer an account',
              href: '/platform/transfers',
              desc: "Choose the type of account you'd like to move to us",
            },
            {
              title: 'Update my details',
              href: '/platform/admin/updatedetails',
              desc: 'Change contact details, banking details, and preferences',
            },
            {
              title: 'Security settings',
              href: '/myaccount/security',
              desc: 'Change your password and set up two-factor authentication',
            },
          ],
        },
      ],
    },
  ],
  trailingMenu: [
    { label: 'Login', href: '/login', icon: 'user' },
    {
      label: 'Account',
      submenu: 'mobile-menu-account-trigger',
      hasSubmenu: true,
    },
    { label: 'Menu', submenu: 'mobile-menu-trigger', hasSubmenu: true },
  ],
};

export default menuDataHardcoded;
